import { skipToken, useQuery } from "@tanstack/react-query";
import { getMerchantsPublicIDFacilitiesFacilityPublicIDPhotos } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const FACILITY_PHOTOS_QUERY_KEY = "FACILITY_PHOTOS";

export const facilityPhotosKeys = {
  all: [FACILITY_PHOTOS_QUERY_KEY],
  byIds: (merchantPublicID: string, facilityPublicID?: string) => [
    ...facilityPhotosKeys.all,
    merchantPublicID,
    facilityPublicID,
  ],
};

/**
 * Stored photos of a facility. Skipped for a facility that is not saved yet or has no photos —
 * the list already says which slots are filled, so there is nothing to fetch.
 */
export const useGetFacilityPhotosQuery = (
  merchantPublicID: string,
  facilityPublicID: string | undefined,
  hasStoredPhotos: boolean,
) =>
  useQuery({
    queryKey: facilityPhotosKeys.byIds(merchantPublicID, facilityPublicID),
    queryFn:
      facilityPublicID && hasStoredPhotos
        ? processResponseWithApiProblemDetails(() =>
            getMerchantsPublicIDFacilitiesFacilityPublicIDPhotos(
              merchantPublicID,
              facilityPublicID,
            ),
          )
        : skipToken,
  });
